import React from 'react';
import { Typography } from '@material-ui/core';

import { Box } from 'components';

import styles from './styles';

const TermsAndPrivacy = () => {
  const classes = styles();

  return (
    <Box>
      <Typography variant="body1" gutterBottom className={classes.labelText}>
        Well done. By signing up, you’ve taken your first step towards a
        happier, invesment portal. We’ll do everything we are happy to help and
        support your business.
      </Typography>
    </Box>
  );
};

export default TermsAndPrivacy;
